/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type HpRespShopByModule_homepage$ref = any;
export type HpRespShopByModule_homepage = {
    readonly shopByModule: ({
        readonly title?: string | null;
        readonly items?: ReadonlyArray<{
            readonly cmsId: number | null;
            readonly title: string | null;
            readonly link: string | null;
            readonly imageUrl: string | null;
        } | null> | null;
    } & ({
        readonly title: string | null;
        readonly items: ReadonlyArray<{
            readonly cmsId: number | null;
            readonly title: string | null;
            readonly link: string | null;
            readonly imageUrl: string | null;
        } | null> | null;
    } | {
        /*This will never be '% other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    })) | null;
    readonly " $refType": HpRespShopByModule_homepage$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "HpRespShopByModule_homepage",
        "type": "Homepage",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            {
                "kind": "LinkedField",
                "alias": "shopByModule",
                "name": "module",
                "storageKey": "module(type:\"shopBy\")",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "shopBy"
                    }
                ],
                "concreteType": null,
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "type": "ShopByModule",
                        "selections": [
                            (v0 /*: any*/),
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "items",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Product",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "cmsId",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    (v0 /*: any*/),
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "link",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "imageUrl",
                                        "args": null,
                                        "storageKey": null
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '7b8e1921f635c7b833cb776cea66e921';
export default node;
